export default __webpack_public_path__ + "SoluceFirstPics.49524c3.png";